import { Injectable } from '@angular/core';
import { GeneratedClientManagerService } from '@cloud-twin-v2/generated/generated-client-manager.service';
import { PointClient } from '@cloud-twin-v2/generated/simulation.generated.client';
import { SelectOption } from '@common-modules/shared/model/shared/select-option';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CtNetworkElementTypesService extends GeneratedClientManagerService {
  private _client: PointClient;

  constructor() {
    super();
    this._client = new PointClient(this.httpClient, this.baseUrl);
  }


  getNetworkElementTypesOptions(scenarioIds: string[], dimensionId: string): Observable<SelectOption<string>[]> {
    return this.getNetworkElementTypesByScenarioAndDimension(dimensionId, scenarioIds).pipe(map(nets => nets.map(net => new SelectOption<string>({
      value: net,
      label: net
    }))));
  }

  getNetworkElementTypesByScenarioAndDimension(dimensionId: string, scenarioIds: string[]) {
    return this._client.getNetworkElementTypes(dimensionId, scenarioIds);
  }
}